import _slicedToArray from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
// @ts-nocheck
function request(method, params, callback) {
  var body = JSON.stringify(params.body || {});
  var headers = new Headers();
  params.headers = params.headers || [];
  Object.entries(params.headers).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        headerName = _ref2[0],
        headerBody = _ref2[1];

    return headers.append(headerName, headerBody);
  });
  fetch(params.url, {
    body: body,
    headers: headers,
    method: method
  }).then(function (response) {
    return response.text();
  }, callback).then(function (responseText) {
    return callback(null, responseText);
  }, callback);
}
/**
 * Use XMLHttpRequest to get a network resource.
 * @param {String} method - HTTP Method
 * @param {Object} params - Request parameters
 * @param {String} params.url - URL of the resource
 * @param {Array}  params.headers - An array of headers to pass [{ headerName : headerBody }]
 * @param {Object} params.body - A JSON body to send to the resource
 * @returns {response}
 */


var Request = request;
/**
 * Sugar function for request('GET', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~get} callback - The callback that handles the response.
 */

Request.get = function get(params, callback) {
  return new this('GET', params, callback);
};
/**
 * Sugar function for request('POST', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~post} callback - The callback that handles the response.
 */


Request.post = function post(params, callback) {
  return new this('POST', params, callback);
};

export default Request;